import { z } from "zod";

// Shared record schemas for the dataset endpoints, kept in the leaf models
// package so routers can `.output()` them without a service → models cycle.
// These mirror `SerializedDataset` / `DatasetArtifactState` from
// `@inference-net/dataset-service`; each consuming procedure's `.output()` makes
// tsc enforce the match, so they cannot silently drift from the service.

// Mirrors SerializedDataset: the datasets table row minus the source-backed
// export internals, with `createdAt`/`archivedAt` serialized to ISO strings.
export const datasetSchema = z.object({
  id: z.string(),
  name: z.string(),
  type: z.string(),
  teamId: z.string(),
  projectId: z.string(),
  filterCriteria: z.unknown(),
  inferenceCount: z.number(),
  lifecycleStatus: z.string(),
  exportStatus: z.string(),
  exportKey: z.string(),
  exportSizeBytes: z.number(),
  duplicateCount: z.number().nullable(),
  exportErrorMessage: z.string(),
  sourceBackedExportStatus: z.string().nullable(),
  sourceBackedExportErrorMessage: z.string().nullable(),
  excludeDatasetId: z.string().nullable(),
  medianInputChars: z.number().nullable(),
  avgInputChars: z.number().nullable(),
  p75InputChars: z.number().nullable(),
  p95InputChars: z.number().nullable(),
  maxInputChars: z.number().nullable(),
  medianOutputChars: z.number().nullable(),
  avgOutputChars: z.number().nullable(),
  p75OutputChars: z.number().nullable(),
  p95OutputChars: z.number().nullable(),
  maxOutputChars: z.number().nullable(),
  samplesWithImages: z.number().nullable(),
  samplesWithStructuredResponse: z.number().nullable(),
  samplesWithToolCall: z.number().nullable(),
  samplesWithInvalidToolCallArguments: z.number().nullable(),
  sourceTeamId: z.string(),
  sourceProjectId: z.string(),
  analysisRunId: z.string().nullable(),
  createdBy: z.string(),
  createdAt: z.string(),
  archivedAt: z.string().nullable(),
});

// `dataset.get` returns a serialized dataset plus the resolved name of the
// excluded eval dataset (training datasets only).
export const datasetWithExcludeNameSchema = datasetSchema.extend({
  excludeDatasetName: z.string().nullable(),
});

// Mirrors DatasetArtifactState from the dataset service.
export const datasetArtifactStateSchema = z.object({
  status: z.string(),
  sizeBytes: z.number(),
  rowCount: z.number(),
  skippedRowCount: z.number(),
  errorMessage: z.string().nullable(),
});
